import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "../base-response";

@JsonConverter
export class BomComponentConverter implements JsonCustomConvert<BomComponent> {
  serialize() { }
  deserialize(data: any): BomComponent {
    const component = new BomComponent();
    component.code = data?.code ?? "";
    component.name = data?.name ?? "";
    component.category = data?.category ?? "";
    component.description = data?.description ?? "";
    component.active = Boolean(data?.active);
    return component;
  }
}

@JsonConverter
export class BomComponentArrayConverter implements JsonCustomConvert<Array<BomComponent>> {
    serialize() { }
    deserialize(data: any): Array<BomComponent> {
      const converter = new BomComponentConverter();
      return (data ?? []).map((item: any) => converter.deserialize(item));
    }
}

@JsonConverter
export class BomComponentListConverter implements JsonCustomConvert<BomComponentList> {
    serialize() { }
    deserialize(data: any): BomComponentList {
      const list = new BomComponentList();
      list.count = Number(data?.count ?? 0);
      list.items = new BomComponentArrayConverter().deserialize(data?.items ?? data?.data ?? []);
      return list;
    }
}

@JsonObject("BomComponent")
export class BomComponent {

    @JsonProperty("code", String, true)
    code: string = "";
    @JsonProperty("name", String, true)
    name: string = "";
    @JsonProperty("category", String, true)
    category: string = "";
    @JsonProperty("description", String, true)
    description: string = "";
    @JsonProperty("active", Boolean, true)
    active: boolean = false;
}

@JsonObject("BomComponentList")
export class BomComponentList {
    @JsonProperty("count", Number, true)
    count: number = 0;
    items: Array<BomComponent> = [];
}

@JsonObject("BomComponentData")
export class BomComponentData extends BaseResponse {
    @JsonProperty("data", BomComponentConverter, true)
    data: BomComponent = new BomComponent();
}

@JsonObject("BomComponentDataArray")
export class BomComponentDataArray extends BaseResponse {
    @JsonProperty("data", BomComponentListConverter, true)
    data: BomComponentList = new BomComponentList();
} 
